/** @jsxImportSource @emotion/react */
import React, { FC, memo, PropsWithChildren } from 'react';
import { Grid, Typography } from '@mui/material';
import { Props } from 'components/ItemGroup/types';

const ItemGroup: FC<PropsWithChildren<Props>> = ({
  title,
  caption,
  children,
}) => {
  return (
    <Grid item>
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Typography variant="h1" color="primary" textTransform="uppercase">
            {title}
            {caption && (
              <Typography
                component="span"
                variant="inherit"
                textTransform="none"
              >
                {' '}
                {caption}
              </Typography>
            )}
          </Typography>
        </Grid>

        {children}
      </Grid>
    </Grid>
  );
};

export default memo(ItemGroup);
